import { action } from 'satcheljs';
import { TableView } from 'owa-mail-list-store';

export default action(
    'ON_KEYBOARD_MARK_AS_JUNK_NOT_JUNK',
    (tableView: TableView, selectedNodeIds: string[], selectedRowKeys: string[]) => ({
        tableView,
        selectedNodeIds,
        selectedRowKeys,
    })
);
